import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import "../styles/faq.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import StoreCta from "./StoreCta";
import { FadeInUp, StaggerChildren, StaggerItem } from "./motion";
import { faqHero, faqItems, faqMeta } from "../content/faq";
import {
  organizationSchema,
  buildFaqSchema,
  buildBreadcrumbSchema,
  innerPageBreadcrumbs,
} from "../content/seo";

const FAQ = () => {
  const faqSchema = buildFaqSchema(faqItems);
  const breadcrumbSchema = buildBreadcrumbSchema(innerPageBreadcrumbs.faq);

  return (
    <main className="faq">
      <PageMeta
        meta={faqMeta}
        jsonLd={[organizationSchema, faqSchema, breadcrumbSchema]}
      />
      <Nav page="faq" />
      <FadeInUp as="header" className="page-hero">
        <h1>{faqHero.title}</h1>
        <p>{faqHero.subtitle}</p>
      </FadeInUp>
      <section className="content-section">
        <StaggerChildren className="faq-list">
          {faqItems.map((item) => (
            <StaggerItem key={item.question}>
              <Accordion disableGutters>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`faq-${item.question}`}
                  id={`faq-header-${item.question}`}
                >
                  <Typography component="h2" variant="h6">
                    {item.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography component="p">{item.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            </StaggerItem>
          ))}
        </StaggerChildren>
        <FadeInUp>
          <StoreCta className="content-cta" />
        </FadeInUp>
      </section>
      <Footer />
    </main>
  );
};

export default FAQ;
